const RequiredData = {
    property: (data, back)=>{
		let errorArray = [];

		if(data.details.property.type) {

			if(data.details.property.type==="Condominium"){
				if(!data.details.property.ctn) {
					let err = {
						"message": `Condominium Certificate of Title number is required.`
					}
					errorArray.push(err);
				}
			}

			if(data.details.property.type==="Land" || data.details.property.type==="Land with Improvement"){
				if(data.details.property.registrationType) {
					if(data.details.property.registrationType==="oct"){
						if(!data.details.property.oct){
							let err = {
								"message": `Original Certificate of Title number is required.`
							}
							errorArray.push(err);
						}
					}
					if(data.details.property.registrationType==="tct"){
						if(!data.details.property.tct){
							let err = {
								"message": `Transfer Certificate of Title number is required.`
							}
							errorArray.push(err);
						}
					}
				} else {
					let err = {
						"message": `Please choose registrastion type.`
					}
					errorArray.push(err);
				}
			}
			
			if (!data.details.property.address) {
				let err = {
					"message": `Address is required.`
				}
				errorArray.push(err);
			}

			if(errorArray.length>0){
                window.location.href=back;
            }
		}
	},
    motorVehicle: (data, back)=>{
        //console.log("POPS", props);
        if(
            !data.details.property.make ||
            !data.details.property.mvFileNo ||
            !data.details.property.series ||
            !data.details.property.plateConductionNo ||
            !data.details.property.bodyType ||
            !data.details.property.engineNo ||
            !data.details.property.yearModel ||
            !data.details.property.chassisNo ||
            !data.details.property.certificateOfRegistrationNo
        ) {
            window.location.href=back;
        }
    },
    price: (data, back)=>{
        if(!data.details.property.price){
            window.location.href=back;
        }
	},
	registryOfDeeds: (data, back)=>{
		if(!data.details.property.registryOfDeeds){
            window.location.href=back;
        }
	},
    area: (data, back)=>{
        if(!data.details.property.area){
            window.location.href=back;
        }
    },
    loan: (data, back)=>{
		// Check if we have a user borrower
		let errorArray = [];
        
        if(!data.details.loan.principal){
            let err = {
                "message": `Please enter principal amount.`
            }
            errorArray.push(err);
        }

        if(!data.details.loan.interestRate){
            let err = {
                "message": `Please enter interest rate.`
            }
            errorArray.push(err);
        }

        if(!data.details.loan.duration){
            let err = {
                "message": `Please enter duration.`
            }
            errorArray.push(err);
        }

        if(errorArray.length>0){
            window.location.href=back;
        }
	},
    seller: (data, back)=>{
        let errorArray = [];
        if(data.details.seller.length>0) {
			data.details.seller.forEach((obj, i)=>{
				
				// Check legal peronality
				if(data.details.seller[i].legalPersonality!==""){
					// Natural person block error
					if(data.details.seller[i].legalPersonality==="Natural Person"){
						// Check if legal age
						if(data.details.seller[i].isLegalAge==="Yes"){
							// Check seller name
							if(
								data.details.seller[i].sellerFname==="" ||
								data.details.seller[i].sellerMname==="" ||
								data.details.seller[i].sellerLname===""
							){
								let err = {
									"message": `Seller #${i+1}: Please complete name.`
								}
								errorArray.push(err);
							}
							// Check seller gender
							if(data.details.seller[i].sellerGender===""){
								let err = {
									"message": `Seller #${i+1}: Please select gender.`
								}
								errorArray.push(err);
							}
							// Check seller marital status
							if(data.details.seller[i].sellerMaritalStatus===""){
								let err = {
									"message": `Seller #${i+1}: Please select marital status.`
								}
								errorArray.push(err);
							} else {
								// If married check spouse full name
								if(data.details.seller[i].sellerMaritalStatus==="Married") {
									if(
										data.details.seller[i].sellerSpouseFname==="" ||
										data.details.seller[i].sellerSpouseMname==="" ||
										data.details.seller[i].sellerSpouseLname===""
									){
										let err = {
											"message": `Seller #${i+1}: Please complete spouse name.`
										}
										errorArray.push(err);
									}
								}
							}
							// Check seller address
							if(data.details.seller[i].sellerAddress===""){
								let err = {
									"message": `Seller #${i+1}: Please complete address.`
								}
								errorArray.push(err);
							}
							// Check seller nationality
							if(data.details.seller[i].sellerNationality===""){
								let err = {
									"message": `Seller #${i+1}: Please complete nationality.`
								}
								errorArray.push(err);
							}
							// Check representative option
							if(data.details.seller[i].sellerHasRepresentative==="Yes"){
								// Check seller representative full name
								if(
									data.details.seller[i].sellerRepresentativeFname==="" ||
									data.details.seller[i].sellerRepresentativeMname==="" ||
									data.details.seller[i].sellerRepresentativeLname===""
								){
									let err = {
										"message": `Seller #${i+1}: Please complete representative name.`
									}
									errorArray.push(err);
								}
								// Check seller representative address
								if(data.details.seller[i].sellerRepresentativeAddress===""){
									let err = {
										"message": `Seller #${i+1}: Please complete representative address.`
									}
									errorArray.push(err);
								}

								// Check seller representative nationality
								if(data.details.seller[i].sellerRepresentativeNationality===""){
									let err = {
										"message": `Seller #${i+1}: Please complete representative nationality.`
									}
									errorArray.push(err);
								}

							}

						} else {
							let err = {
								"message": `Seller #${i+1}: Is not legal age.`
							}					
							errorArray.push(err);
						}

					}
					
					// Check corporation block
					if(data.details.seller[i].legalPersonality==="Corporation"){
						// Check corporation name
						if(data.details.seller[i].sellerCorporationName===""){
							let err = {
								"message": `Seller #${i+1}: Please complete corporation name.`
							}
							errorArray.push(err);
						}
						// Check principal place of business
						if(data.details.seller[i].sellerCorporationPrincipalPlaceOfBusiness===""){
							let err = {
								"message": `Seller #${i+1}: Please complete corporation principal place of business.`
							}
							errorArray.push(err);
						}
						// Check corporation representative
						if(
							data.details.seller[i].sellerCorporationRepresentativeFname==="" ||
							data.details.seller[i].sellerCorporationRepresentativeMname==="" ||
							data.details.seller[i].sellerCorporationRepresentativeLname===""
						){
							let err = {
								"message": `Seller #${i+1}: Please complete corporation representative name.`
							}
							errorArray.push(err);
						}
						// Check corporation representative position
						if(data.details.seller[i].sellerCorporationRepresentativePosition===""){
							let err = {
								"message": `Seller #${i+1}: Please complete position of the representative.`
							}
							errorArray.push(err);
						}

					}

				} else {
					let err = {
						"message": `Please select legal personality for seller #${i+1}.`
					}
					errorArray.push(err);
				}
				
			});

            if(errorArray.length>0) {
                window.location.href=back;
            }
		}
    },
    buyer: (data, back)=>{
        let errorArray = [];
        if(data.details.buyer.length>0) {
			data.details.buyer.forEach((obj, i)=>{
				
				// Check legal peronality
				if(data.details.buyer[i].legalPersonality!==""){
					// Natural person block error
					if(data.details.buyer[i].legalPersonality==="Natural Person"){
						// Check if legal age
						if(data.details.buyer[i].isLegalAge==="Yes"){
							// Check buyer name
							if(
								data.details.buyer[i].buyerFname==="" ||
								data.details.buyer[i].buyerMname==="" ||
								data.details.buyer[i].buyerLname===""
							){
								let err = {
									"message": `buyer #${i+1}: Please complete name.`
								}
								errorArray.push(err);
							}
							// Check buyer gender
							if(data.details.buyer[i].buyerGender===""){
								let err = {
									"message": `buyer #${i+1}: Please select gender.`
								}
								errorArray.push(err);
							}
							// Check buyer marital status
							if(data.details.buyer[i].buyerMaritalStatus===""){
								let err = {
									"message": `buyer #${i+1}: Please select marital status.`
								}
								errorArray.push(err);
							} else {
								// If married check spouse full name
								if(data.details.buyer[i].buyerMaritalStatus==="Married") {
									if(
										data.details.buyer[i].buyerSpouseFname==="" ||
										data.details.buyer[i].buyerSpouseMname==="" ||
										data.details.buyer[i].buyerSpouseLname===""
									){
										let err = {
											"message": `buyer #${i+1}: Please complete spouse name.`
										}
										errorArray.push(err);
									}
								}
							}
							// Check buyer address
							if(data.details.buyer[i].buyerAddress===""){
								let err = {
									"message": `buyer #${i+1}: Please complete address.`
								}
								errorArray.push(err);
							}
							// Check buyer nationality
							if(data.details.buyer[i].buyerNationality===""){
								let err = {
									"message": `buyer #${i+1}: Please complete nationality.`
								}
								errorArray.push(err);
							}
							// Check representative option
							if(data.details.buyer[i].buyerHasRepresentative==="Yes"){
								// Check buyer representative full name
								if(
									data.details.buyer[i].buyerRepresentativeFname==="" ||
									data.details.buyer[i].buyerRepresentativeMname==="" ||
									data.details.buyer[i].buyerRepresentativeLname===""
								){
									let err = {
										"message": `buyer #${i+1}: Please complete representative name.`
									}
									errorArray.push(err);
								}
								// Check buyer representative address
								if(data.details.buyer[i].buyerRepresentativeAddress===""){
									let err = {
										"message": `buyer #${i+1}: Please complete representative address.`
									}
									errorArray.push(err);
								}

								// Check buyer representative nationality
								if(data.details.buyer[i].buyerRepresentativeNationality===""){
									let err = {
										"message": `buyer #${i+1}: Please complete representative nationality.`
									}
									errorArray.push(err);
								}

							}

						} else {
							let err = {
								"message": `buyer #${i+1}: Is not legal age.`
							}					
							errorArray.push(err);
						}

					}
					
					// Check corporation block
					if(data.details.buyer[i].legalPersonality==="Corporation"){
						// Check corporation name
						if(data.details.buyer[i].buyerCorporationName===""){
							let err = {
								"message": `buyer #${i+1}: Please complete corporation name.`
							}
							errorArray.push(err);
						}
						// Check principal place of business
						if(data.details.buyer[i].buyerCorporationPrincipalPlaceOfBusiness===""){
							let err = {
								"message": `buyer #${i+1}: Please complete corporation principal place of business.`
							}
							errorArray.push(err);
						}
						// Check corporation representative
						if(
							data.details.buyer[i].buyerCorporationRepresentativeFname==="" ||
							data.details.buyer[i].buyerCorporationRepresentativeMname==="" ||
							data.details.buyer[i].buyerCorporationRepresentativeLname===""
						){
							let err = {
								"message": `buyer #${i+1}: Please complete corporation representative name.`
							}
							errorArray.push(err);
						}
						// Check corporation representative position
						if(data.details.buyer[i].buyerCorporationRepresentativePosition===""){
							let err = {
								"message": `buyer #${i+1}: Please complete position of the representative.`
							}
							errorArray.push(err);
						}

					}

				} else {
					let err = {
						"message": `Please select legal personality for buyer #${i+1}.`
					}
					errorArray.push(err);
				}
				
			});

            if(errorArray.length>0) {
                window.location.href=back;
            }
		}
    },
    lender: (data, back)=>{
		// Check if we have a user lender
		let errorArray = [];

		if(data.details.lender.length>0) {
			data.details.lender.forEach((obj, i)=>{
				
				// Check legal peronality
				if(data.details.lender[i].legalPersonality!==""){
					// Natural person block error
					if(data.details.lender[i].legalPersonality==="Natural Person"){
						// Check if legal age
						if(data.details.lender[i].isLegalAge==="Yes"){
							// Check lender name
							if(
								data.details.lender[i].lenderFname==="" ||
								data.details.lender[i].lenderMname==="" ||
								data.details.lender[i].lenderLname===""
							){
								let err = {
									"message": `lender #${i+1}: Please complete name.`
								}
								errorArray.push(err);
							}
							// Check lender gender
							if(data.details.lender[i].lenderGender===""){
								let err = {
									"message": `lender #${i+1}: Please select gender.`
								}
								errorArray.push(err);
							}

						} else {
							let err = {
								"message": `lender #${i+1}: Is not legal age.`
							}					
							errorArray.push(err);
						}

					}
					
					// Check corporation block
					if(data.details.lender[i].legalPersonality==="Corporation"){
						// Check corporation name
						if(data.details.lender[i].lenderCorporationName===""){
							let err = {
								"message": `lender #${i+1}: Please complete corporation name.`
							}
							errorArray.push(err);
						}

					}

				} else {
					let err = {
						"message": `Please select legal personality for lender #${i+1}.`
					}
					errorArray.push(err);
				}

				return
				
			});

			if(errorArray.length>0){
                window.location.href=back;
            }
		}
    },
    borrower: (data, back)=>{
		// Check if we have a user borrower
		let errorArray = [];

		if(data.details.borrower.length>0) {
			data.details.borrower.forEach((obj, i)=>{
				
				// Check legal peronality
				if(data.details.borrower[i].legalPersonality!==""){
					// Natural person block error
					if(data.details.borrower[i].legalPersonality==="Natural Person"){
						// Check if legal age
						if(data.details.borrower[i].isLegalAge==="Yes"){
							// Check borrower name
							if(
								data.details.borrower[i].borrowerFname==="" ||
								data.details.borrower[i].borrowerMname==="" ||
								data.details.borrower[i].borrowerLname===""
							){
								let err = {
									"message": `borrower #${i+1}: Please complete name.`
								}
								errorArray.push(err);
							}
							// Check borrower gender
							if(data.details.borrower[i].borrowerGender===""){
								let err = {
									"message": `borrower #${i+1}: Please select gender.`
								}
								errorArray.push(err);
							}

						} else {
							let err = {
								"message": `borrower #${i+1}: Is not legal age.`
							}					
							errorArray.push(err);
						}

					}
					
					// Check corporation block
					if(data.details.borrower[i].legalPersonality==="Corporation"){
						// Check corporation name
						if(data.details.borrower[i].borrowerCorporationName===""){
							let err = {
								"message": `borrower #${i+1}: Please complete corporation name.`
							}
							errorArray.push(err);
						}
						// Check corporation representative
						if(
							data.details.borrower[i].borrowerCorporationRepresentativeFname==="" ||
							data.details.borrower[i].borrowerCorporationRepresentativeMname==="" ||
							data.details.borrower[i].borrowerCorporationRepresentativeLname===""
						){
							let err = {
								"message": `borrower #${i+1}: Please complete corporation representative name.`
							}
							errorArray.push(err);
						}
						// Check corporation representative position
						if(data.details.borrower[i].borrowerCorporationRepresentativePosition===""){
							let err = {
								"message": `borrower #${i+1}: Please complete position of the representative.`
							}
							errorArray.push(err);
                        }
                        if(!data.details.borrower[i].borrowerCorporationRepresentativeGender){
                            let err = {
								"message": `Please select gender.`
							}
							errorArray.push(err);
                        }

					}

				} else {
					let err = {
						"message": `Please select legal personality for borrower #${i+1}.`
					}
					errorArray.push(err);
				}

				return
				
			});

			if(errorArray.length>0) {
                window.location.href=back;
            }
		}
    },
    corporation: (data, back)=>{
		let errorArray = [];
		if(
			!data.details.corporation.name ||
			!data.details.corporation.address ||
			!data.details.corporation.representativeFname ||
			!data.details.corporation.representativeMname ||
			!data.details.corporation.representativeLname ||
			!data.details.corporation.representativePosition ||
			!data.details.corporation.meetingDate ||
			(data.details.corporation.bod.length ===0)
		) {
			let err = {
				"message": `All fields are required.`
			}
			errorArray.push(err);
		}

        if(errorArray.length>0){
            window.location.href=back;
        }
    },
    earnestMoney: (data, back)=>{
        let errorArray = [];
        if(
            data.details.property.earnestMoneyAmount==="" ||
            data.details.property.price==="" ||
            data.details.property.daysReserved===""
            ) {
            let err = {
                "message": `All fields are required.`
            }
            errorArray.push(err);
        } 
        if(errorArray.length>0){
            window.location.href=back;
        }

	},
	optionMoney: (data, back)=>{
        let errorArray = [];
        if(
            data.details.property.optionMoneyAmount==="" ||
            data.details.property.price==="" ||
            data.details.property.daysReserved===""
            ) {
            let err = {
                "message": `All fields are required.`
            }
            errorArray.push(err);
        } 
        if(errorArray.length>0){
            window.location.href=back;
        }

	},
	secretaryCertificate: (data, back)=>{
		let errorArray = [];
		if(
			!data.details.corporation.name ||
			!data.details.corporation.address ||
			!data.details.corporation.secretaryFname ||
			!data.details.corporation.secretaryMname ||
			!data.details.corporation.secretaryLname ||
			!data.details.corporation.secretaryGender ||
			!data.details.corporation.representativeFname ||
			!data.details.corporation.representativeMname ||
			!data.details.corporation.representativeLname ||
			!data.details.corporation.representativePosition ||
			!data.details.corporation.meetingDate ||
			!data.details.property.price ||
			!data.details.property.area
			) {

				let err = {
					"message": `All fields are required.`
				}
				errorArray.push(err);

		}
		if(errorArray.length>0){
			window.location.href=back;
		}
	},
	representative: (data, back)=>{
		let errorArray = [];
		if(
			!data.details.representative.fname ||
			!data.details.representative.mname ||
			!data.details.representative.lname ||
			!data.details.representative.gender ||
			!data.details.representative.address ||
			!data.details.representative.nationality
			){
			let err = {
				"message": `All fields are required.`
			}
			errorArray.push(err);
		}
		if(errorArray.length>0){
			window.location.href=back;
		}
	},
	contractToSell4: (data, back)=>{
        let errorArray = [];

        if(data.details.property.price==="") {
            let err = {
                "message": `Selling price is required.`
            }
            errorArray.push(err);
		}
		if(data.details.property.price.length>15){
			let err = {
				"message": `Price digit has max out.`
			}
			errorArray.push(err);
		}
		if(data.details.property.downpayment==="") {
			let err = {
                "message": `Downpayment is required.`
            }
            errorArray.push(err);
		}
		if(data.details.property.earnestMoney==="Yes"){
			if(data.details.property.earnestMoneyAmount===""){
				let err = {
					"message": `Earnest money amount is required.`
				}
				errorArray.push(err);
			}
			if(data.details.property.earnestMoneyReceived===""){
				let err = {
					"message": `Earnest money date received is required.`
				}
				errorArray.push(err);
			}
		}
		if(errorArray.length>0){
			window.location.href=back;
		}
	},
	contractToSell6: (data, back)=>{
        let errorArray = [];
        if(
            data.details.property.possession==="" ||
            data.details.property.monthsToPayBalance==="" ||
            data.details.property.firstInstallmentDue==="" ||
            data.details.property.checkPayee===""
        ) {
            let err = {
                "message": `All fields are required.`
            }
            errorArray.push(err);
		}
		if(errorArray.length>0){
			window.location.href=back;
		}
	},
	mortgagor: (data, back)=>{
        let errorArray = [];
        if(data.details.mortgagor.length>0) {
			data.details.mortgagor.forEach((obj, i)=>{
				
				// Check legal peronality
				if(data.details.mortgagor[i].legalPersonality!==""){
					// Natural person block error
					if(data.details.mortgagor[i].legalPersonality==="Natural Person"){
						// Check if legal age
						if(data.details.mortgagor[i].isLegalAge==="Yes"){
							// Check mortgagor name
							if(
								data.details.mortgagor[i].mortgagorFname==="" ||
								data.details.mortgagor[i].mortgagorMname==="" ||
								data.details.mortgagor[i].mortgagorLname===""
							){
								let err = {
									"message": `mortgagor #${i+1}: Please complete name.`
								}
								errorArray.push(err);
							}
							// Check mortgagor gender
							if(data.details.mortgagor[i].mortgagorGender===""){
								let err = {
									"message": `mortgagor #${i+1}: Please select gender.`
								}
								errorArray.push(err);
							}
							// Check mortgagor marital status
							if(data.details.mortgagor[i].mortgagorMaritalStatus===""){
								let err = {
									"message": `mortgagor #${i+1}: Please select marital status.`
								}
								errorArray.push(err);
							} else {
								// If married check spouse full name
								if(data.details.mortgagor[i].mortgagorMaritalStatus==="Married") {
									if(
										data.details.mortgagor[i].mortgagorSpouseFname==="" ||
										data.details.mortgagor[i].mortgagorSpouseMname==="" ||
										data.details.mortgagor[i].mortgagorSpouseLname===""
									){
										let err = {
											"message": `mortgagor #${i+1}: Please complete spouse name.`
										}
										errorArray.push(err);
									}
								}
							}
							// Check mortgagor address
							if(data.details.mortgagor[i].mortgagorAddress===""){
								let err = {
									"message": `mortgagor #${i+1}: Please complete address.`
								}
								errorArray.push(err);
							}
							// Check mortgagor nationality
							if(data.details.mortgagor[i].mortgagorNationality===""){
								let err = {
									"message": `mortgagor #${i+1}: Please complete nationality.`
								}
								errorArray.push(err);
							}
							// Check representative option
							if(data.details.mortgagor[i].mortgagorHasRepresentative==="Yes"){
								// Check mortgagor representative full name
								if(
									data.details.mortgagor[i].mortgagorRepresentativeFname==="" ||
									data.details.mortgagor[i].mortgagorRepresentativeMname==="" ||
									data.details.mortgagor[i].mortgagorRepresentativeLname===""
								){
									let err = {
										"message": `mortgagor #${i+1}: Please complete representative name.`
									}
									errorArray.push(err);
								}
								// Check mortgagor representative address
								if(data.details.mortgagor[i].mortgagorRepresentativeAddress===""){
									let err = {
										"message": `mortgagor #${i+1}: Please complete representative address.`
									}
									errorArray.push(err);
								}

								// Check mortgagor representative nationality
								if(data.details.mortgagor[i].mortgagorRepresentativeNationality===""){
									let err = {
										"message": `mortgagor #${i+1}: Please complete representative nationality.`
									}
									errorArray.push(err);
								}

							}

						} else {
							let err = {
								"message": `mortgagor #${i+1}: Is not legal age.`
							}					
							errorArray.push(err);
						}

					}
					
					// Check corporation block
					if(data.details.mortgagor[i].legalPersonality==="Corporation"){
						// Check corporation name
						if(data.details.mortgagor[i].mortgagorCorporationName===""){
							let err = {
								"message": `mortgagor #${i+1}: Please complete corporation name.`
							}
							errorArray.push(err);
						}
						// Check principal place of business
						if(data.details.mortgagor[i].mortgagorCorporationPrincipalPlaceOfBusiness===""){
							let err = {
								"message": `mortgagor #${i+1}: Please complete corporation principal place of business.`
							}
							errorArray.push(err);
						}
						// Check corporation representative
						if(
							data.details.mortgagor[i].mortgagorCorporationRepresentativeFname==="" ||
							data.details.mortgagor[i].mortgagorCorporationRepresentativeMname==="" ||
							data.details.mortgagor[i].mortgagorCorporationRepresentativeLname===""
						){
							let err = {
								"message": `mortgagor #${i+1}: Please complete corporation representative name.`
							}
							errorArray.push(err);
						}
						// Check corporation representative position
						if(data.details.mortgagor[i].mortgagorCorporationRepresentativePosition===""){
							let err = {
								"message": `mortgagor #${i+1}: Please complete position of the representative.`
							}
							errorArray.push(err);
						}

					}

				} else {
					let err = {
						"message": `Please select legal personality for mortgagor #${i+1}.`
					}
					errorArray.push(err);
				}
				
			});

            if(errorArray.length>0) {
                window.location.href=back;
            }
		}
	},
	mortgagee: (data, back)=>{
        let errorArray = [];
        if(data.details.mortgagee.length>0) {
			data.details.mortgagee.forEach((obj, i)=>{
				
				// Check legal peronality
				if(data.details.mortgagee[i].legalPersonality!==""){
					// Natural person block error
					if(data.details.mortgagee[i].legalPersonality==="Natural Person"){
						// Check if legal age
						if(data.details.mortgagee[i].isLegalAge==="Yes"){
							// Check mortgagee name
							if(
								data.details.mortgagee[i].mortgageeFname==="" ||
								data.details.mortgagee[i].mortgageeMname==="" ||
								data.details.mortgagee[i].mortgageeLname===""
							){
								let err = {
									"message": `mortgagee #${i+1}: Please complete name.`
								}
								errorArray.push(err);
							}
							// Check mortgagee gender
							if(data.details.mortgagee[i].mortgageeGender===""){
								let err = {
									"message": `mortgagee #${i+1}: Please select gender.`
								}
								errorArray.push(err);
							}
							// Check mortgagee marital status
							if(data.details.mortgagee[i].mortgageeMaritalStatus===""){
								let err = {
									"message": `mortgagee #${i+1}: Please select marital status.`
								}
								errorArray.push(err);
							} else {
								// If married check spouse full name
								if(data.details.mortgagee[i].mortgageeMaritalStatus==="Married") {
									if(
										data.details.mortgagee[i].mortgageeSpouseFname==="" ||
										data.details.mortgagee[i].mortgageeSpouseMname==="" ||
										data.details.mortgagee[i].mortgageeSpouseLname===""
									){
										let err = {
											"message": `mortgagee #${i+1}: Please complete spouse name.`
										}
										errorArray.push(err);
									}
								}
							}
							// Check mortgagee address
							if(data.details.mortgagee[i].mortgageeAddress===""){
								let err = {
									"message": `mortgagee #${i+1}: Please complete address.`
								}
								errorArray.push(err);
							}
							// Check mortgagee nationality
							if(data.details.mortgagee[i].mortgageeNationality===""){
								let err = {
									"message": `mortgagee #${i+1}: Please complete nationality.`
								}
								errorArray.push(err);
							}
							// Check representative option
							if(data.details.mortgagee[i].mortgageeHasRepresentative==="Yes"){
								// Check mortgagee representative full name
								if(
									data.details.mortgagee[i].mortgageeRepresentativeFname==="" ||
									data.details.mortgagee[i].mortgageeRepresentativeMname==="" ||
									data.details.mortgagee[i].mortgageeRepresentativeLname===""
								){
									let err = {
										"message": `mortgagee #${i+1}: Please complete representative name.`
									}
									errorArray.push(err);
								}
								// Check mortgagee representative address
								if(data.details.mortgagee[i].mortgageeRepresentativeAddress===""){
									let err = {
										"message": `mortgagee #${i+1}: Please complete representative address.`
									}
									errorArray.push(err);
								}

								// Check mortgagee representative nationality
								if(data.details.mortgagee[i].mortgageeRepresentativeNationality===""){
									let err = {
										"message": `mortgagee #${i+1}: Please complete representative nationality.`
									}
									errorArray.push(err);
								}

							}

						} else {
							let err = {
								"message": `mortgagee #${i+1}: Is not legal age.`
							}					
							errorArray.push(err);
						}

					}
					
					// Check corporation block
					if(data.details.mortgagee[i].legalPersonality==="Corporation"){
						// Check corporation name
						if(data.details.mortgagee[i].mortgageeCorporationName===""){
							let err = {
								"message": `mortgagee #${i+1}: Please complete corporation name.`
							}
							errorArray.push(err);
						}
						// Check principal place of business
						if(data.details.mortgagee[i].mortgageeCorporationPrincipalPlaceOfBusiness===""){
							let err = {
								"message": `mortgagee #${i+1}: Please complete corporation principal place of business.`
							}
							errorArray.push(err);
						}
						// Check corporation representative
						if(
							data.details.mortgagee[i].mortgageeCorporationRepresentativeFname==="" ||
							data.details.mortgagee[i].mortgageeCorporationRepresentativeMname==="" ||
							data.details.mortgagee[i].mortgageeCorporationRepresentativeLname===""
						){
							let err = {
								"message": `mortgagee #${i+1}: Please complete corporation representative name.`
							}
							errorArray.push(err);
						}
						// Check corporation representative position
						if(data.details.mortgagee[i].mortgageeCorporationRepresentativePosition===""){
							let err = {
								"message": `mortgagee #${i+1}: Please complete position of the representative.`
							}
							errorArray.push(err);
						}

					}

				} else {
					let err = {
						"message": `Please select legal personality for mortgagee #${i+1}.`
					}
					errorArray.push(err);
				}
				
			});

            if(errorArray.length>0) {
                window.location.href=back;
            }
		}
	},
	realEstateMortgage4: (data, back)=>{
		let errorArray = [];
        if(
            !data.details.property.loanAmount ||
            !data.details.property.loanInterestBasis ||
            !data.details.property.loanInterestRate ||
            !data.details.property.loanDuration
        ) {
            let err = {
                "message": `All fields are required.`
            }
            errorArray.push(err);
		}
		if(errorArray.length>0){
			window.location.href=back;
		}
	},
	realEstateMortgage5: (data, back)=>{
		let errorArray = [];
        if(
            !data.details.property.requireFireInsurance ||
            !data.details.property.registerMortgage ||
            !data.details.property.paymentFees ||
            !data.details.property.paymentDefault
            ) {
            let err = {
                "message": `All fields are required.`
            }
            errorArray.push(err);
        } 
		if(errorArray.length>0){
			window.location.href=back;
		}
	}
}

export default RequiredData;


// WEBPACK FOOTER //
// ./src/model/RequiredData.js